import React, {useState, useEffect} from 'react'
//! Styles
import './appm-4.style.css'
//! SweetAlert
import Swal from 'sweetalert2'
//! Axios
import axios from 'axios'
import moment from 'moment-timezone'
import { Base_API } from '../../_actions/matcher'
import { DecryptedOBJ, DecryptedText } from '../../utils/Encryption'


function Appointment_4() {

    const [errorMsg, setErrorMsg] = useState('');
    const [errorStatus, setErrorStatus] = useState(false);
    const [statementPreview, setStatementPreview] = useState('');
    const [packOrder, setPackOrder] = useState([]);
    const [totalPriceOrder, setTotalPriceOrder] = useState(0);
    const [uploadStatus, setUploadStatus] = useState(false);
    const [percent, setPercent] = useState(0);
    const [orderQuantity, setOrderQuantity] = useState(0);
    // form api
    const [fileName, setFileName] = useState("");

    // check & clear
    useEffect(() => {
        // check
        if(window.localStorage.getItem('formData_page-3') === null)
        {
            onBack();
        }    
        if(window.localStorage.getItem('package_selected') === null)
        {
            window.location.href = `${Base_API.main}/n-health/packages`; 
        }
        // clear
        if(window.localStorage.getItem('formData_page-4') !== null)
        {
            window.localStorage.removeItem('formData_page-4');
            window.location.reload();
        }

        handleConfirmOrder();
    },[])

    const showAlert = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }

    const handleConfirmOrder = () => {
        let packOrder = DecryptedOBJ(window.localStorage.getItem('package_selected'));
        let form_2 = DecryptedOBJ(window.localStorage.getItem('formData_page-2'));
        let form_3 = DecryptedOBJ(window.localStorage.getItem('formData_page-3'));
        let totalPrice = DecryptedText(window.localStorage.getItem('total_price'));
        let odquantity = packOrder.map(item => item.quantity_selected).reduce((a, b) => a+b);
        setOrderQuantity(Number(odquantity));
        setTotalPriceOrder(Number(totalPrice));
    }
    const onBack = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/form/3`;
    }
    const onSubmit = () => {
        const packOrder = DecryptedOBJ(window.localStorage.getItem('package_selected'));
        const form_2 = DecryptedOBJ(window.localStorage.getItem('formData_page-2'));
        const form_3 = DecryptedOBJ(window.localStorage.getItem('formData_page-3')); 
        const totalPrice = DecryptedText(window.localStorage.getItem('total_price'));
        let packageName = []
        let appointmentText = "";
        let apmDate = String(form_3.appointment_date).replaceAll("-", "/");
        let packages = packOrder.map(order => {
            return {
                packages_code: order.code,
                packages_name: order.pack_type_th,
                package_price: Number(order.flashdeal_price),
                total_amount: order.quantity_selected,
                total_price: Number(totalPrice)
            }            
            
        })
        packageName = packOrder.map(order => order.pack_type_th)

        let lineProfile = {
            display_name: '',
            user_id: '',
            id_token: '',
            picture_url: ''
        };
        if(window.localStorage.getItem('line_profile') !== null)
        {
            let data = DecryptedOBJ(window.localStorage.getItem('line_profile'));

            lineProfile = {
                display_name: data.display_name,
                user_id: data.user_id,
                id_token: data.id_token,
                picture_url: data.picture_url
            }
        }


        let formData = {
            tranchannel: "LINE OA",
            firstname: form_2[0].value,
            lastname: form_2[1].value,
            birthday: form_2[2].value,
            phoneno: form_2[3].value,
            email: form_2[4].value,
            filename_refUpload: fileName,
            refPaychannel: "bank_transfer",
            packages_name: String(packageName),
            total_amount: orderQuantity,
            total_price: Number(totalPriceOrder),
            appointmentDate: `${form_3.time === '' || form_3.appointment_date === '' ? '' : form_3.appointment_date} ${form_3.time}`,
            receive_service_code: form_3.hospital_id,
            receive_service: form_3.hospital_name,
            package: packages,
            line_display: lineProfile.display_name,
            line_user: lineProfile.user_id,
            line_token: lineProfile.id_token,
            line_profile: lineProfile.picture_url 
        }
        // console.log(formData)

        if(uploadStatus) 
        {
            // axios.post('https://nhealth-lab.podrealm.com/Transections/_comfirm_transections',
            // axios.post('https://weblabonline.nhealth-asia.com/backoffice-lineoa/Transections/_comfirm_transections',
            // axios.post('https://onlineshop.nhealth-asia.com/backoffice/Transections/_comfirm_transections',
            axios.post(Base_API.api_confirm_transaction,
            formData,
            {headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            }}
            )
            .then(res => {
                // console.log(res)
                if(res.data.isSuccess === true)
                {
                    window.location.href = `${Base_API.pathWeb}/n-health/form/5`
                }
            })
            .catch(err => {
                // console.error(err)
            });

            // test
            // window.location.href = '/lineoa/n-health/form/5'
        }else
        {
            showAlert('กรุณาชำระเงินและอัปโหลดสลิป.');
        }
    }

    function GetLineProfile() {
        let lineProfile = localStorage.getItem('line_profile');
        var accessToken;
        if(!!lineProfile && lineProfile !== null && lineProfile !== "" && lineProfile !== undefined)
        {
            accessToken = DecryptedOBJ(localStorage.getItem('line_profile')).access_token;
            return accessToken;
        }
        return accessToken;
    }

    const onUploadFile = (file) => {
        // for preivew
        let fileType = String(file.type).split("/")[1];
        let urlPreview = URL.createObjectURL(file);
        //console.log(urlPreview) 
        if(fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png')
        {
            setStatementPreview(urlPreview);
        }else
        {
            showAlert('กรุณาอัปโหลดไฟล์ png, jpg, jpeg.');
        }

        // upload to api
        let formData = new FormData();
        formData.append('input type file', file);

        axios.post(Base_API.api_upload_payment, formData, {headers: {access_token: GetLineProfile()}})
        // axios.post('https://weblabonline.nhealth-asia.com/backoffice-lineoa/Transections/_upload_ref_transfers', formData)
        // axios.post('https://onlineshop.nhealth-asia.com/backoffice/Transections/_upload_ref_transfers', formData)
        .then(res => {
            // console.log(res);
            if(res.data.isSuccess === true)
            {
                setFileName(res.data.dataMessage);
                setUploadStatus(true)
                // console.log(res.data.dataMessage)
            }
            else
            {
                console.error("Error API: upload Statement(Slip)")
                setUploadStatus(false)
            }
        })
        .catch(err => {
            // console.log(err)
        })
    }

    return (
        <div className="appm-4_container">
            <div className="appm-4-form_wrapper">
                {/* header */}
                <h1 className="appm-4-form_header">แจ้งชำระเงิน</h1>
                {/* title */}
                <h2 className="appm-4-form_title">บัญชีธนาคาร</h2>

                {/* paymeny item */}
                <div className="appm-4-paymeny-itemwrap">
                    <div className="appm-4-paymeny-item space">
                        <span className="appm-4-paymeny-itemleft">บัญชีธนาคาร</span>
                        <span className="appm-4-paymeny-itemright">ธนาคารไทยพาณิชย์</span>
                    </div>
                    <div className="appm-4-paymeny-item">
                        <span className="appm-4-paymeny-itemleft">ชื่อบัญชี</span>
                        <span className="appm-4-paymeny-itemright">N HEALTH</span>
                    </div>
                    <div className="appm-4-paymeny-item">
                        <span className="appm-4-paymeny-itemleft">เลขบัญชี</span>
                        <a href="tel:043-2-77501-9" className="appm-4-paymeny-itemright">043-2-77501-9 <a className='appm-4-textclipboard' href="tel:043-2-77501-9">COPY</a></a>
                    </div>
                    <div className="appm-4-paymeny-item">
                        <span className="appm-4-paymeny-itemleft">จำนวนเงินที่ต้องชำระ</span>
                        <span className="appm-4-paymeny-itemright">{Number(totalPriceOrder).toLocaleString('th')}.00 บาท</span>
                    </div>
                </div>

                {/* button upload statement */}
                <div className="appm-4-paymeny-upload_wrapper">
                    <input onChange={(e) => onUploadFile(e.target.files[0])} type="file" id="appm-4-paymeny-statement-upload" name="statement-file" />
                    <label htmlFor="appm-4-paymeny-statement-upload"><i className="bi bi-paperclip"></i> อัพโหลดสลิป</label>
                </div>

                {/* statement preview */}
                <div className="appm-4-statement_preview">
                    <img src={statementPreview} alt="statement preview" style={statementPreview.length > 0 ? {opacity: 1} : {opacity: 0}} /> 
                </div>

                {/* button */}
                <div className="appm-4-button_wrapper">
                    <button 
                        className="appm-4-btn_back"
                        onClick={onBack}
                    >
                        ย้อนกลับ
                    </button>
                    <button 
                        className="appm-4-btn_submit"
                        onClick={onSubmit}
                    >
                        ชำระเงิน
                    </button>
                </div>
            </div>
            {/* footer */}
            <p className="footer-text">Copyright © 2022 National Healthcare Systems Company Limited All rights reserved</p> 
        </div>
    )
}

export default Appointment_4